import { useSelector } from 'react-redux';
import { getDb } from '../../firebase';

const useDataLinkDatabase = () => {
  const { parameters } = useSelector(state => state.DataLinks);

  const connection = dataLinkId => {
    if (!dataLinkId || !parameters || !parameters[dataLinkId]) {
      return getDb();
    }

    const { databaseId } = parameters[dataLinkId];
    if (
      databaseId.trim().length === 0 ||
      databaseId.toLowerCase() === 'default' ||
      databaseId.toLowerCase() === '(default)'
    ) {
      return getDb();
    }

    return getDb(databaseId);
  };

  const getDatabaseId = dataLinkId => {
    if (!dataLinkId || !parameters || !parameters[dataLinkId]) {
      return '(default)';
    }

    const { databaseId } = parameters[dataLinkId];
    if (
      databaseId.trim().length === 0 ||
      databaseId.toLowerCase() === 'default' ||
      databaseId.toLowerCase() === '(default)'
    ) {
      return '(default)';
    }

    return databaseId;
  };

  return {
    getDb: connection,
    getDatabaseId
  };
};

export default useDataLinkDatabase;
